<template>
	<div class="m-auto d-flex algin-center justify-center flex-column" style="text-align: center">
		<img src="../../public/img/images/404.svg" style="width: 500px;" class="p-vertical-15" />
		<span class="p-vertical-15">Uh oh, this page doesn't exist</span>

		<v-btn class="p-vertical-15" depressed color="accent" to="/dashboard">Dashboard</v-btn>
	</div>
</template>

<script>
export default {};
</script>

<style>
.m-auto {
	margin: auto;
}

.huge-text {
	font-size: 6.5em;
}
</style>
